<template>
  <div class="categories" style="background-color: #111130;">
    <div style="margin-top:10px;">
      <v-card-text v-for="item in items">
        <div class="row mb-1">
          <div class="col-md-12  main-result" style="border: 1px #c1c1c1 solid;
    padding: 10px;
    border-radius: 5px;
margin: 2px">
            <div class="main">
              <h4 class="h">
                <a @click="go_to_info(item)" target="_blank" style="text-decoration: none;">{{item.PageSeoTitle}}</a>
                <br>
              </h4>
              <div class="b">

                <span class="meta" style="color: white">{{item.PageMeta}}</span>
              </div>
            </div>
            <br>

          </div>
        </div>

      </v-card-text>

    </div>
    <infinite-loading @infinite="get_searches">
      <template slot="no-more">{{ $t('thereIsNothing') }}</template>
      <template slot="no-results">{{ $t('noResult') }}</template>
      <template slot="spinner">{{ $t('loading') }}</template>

    </infinite-loading>
  </div>
</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  export default {
    props: [
      'passing_data'
    ],
    components: {
      InfiniteLoading
    },
    data () {
      return {
        errors: [],
        items: [],
        page: 1,
        rules: {
          required: value => !!value || this.$t('necessary'),
          fullName: value => value.length <= 30 || this.$t('max30Character'),
          PersianFullName: value => {
            const pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاتنمکگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
            return pattern.test(value) || this.$t('nameNotFarsi')
          },
          mobile: value => {
            const pattern = /^(\+98|0098|98|0)?9\d{9}$/
            return pattern.test(value) || this.$t('phoneNotCorrect')
          },
        },
      }
    },
    watch: {},
    mounted () {
      var passing_data = JSON.parse(localStorage.getItem('request_data'))
      this.get_searches()
    },
    methods: {
      go_to_info (item) {
        if (item.IsPage == 1) {
          // this.$router.push({ path: '/blog-info/' + item.PageUrlGroup + '/' + item.PageKeyWord })
          window.open("https://blog.zoodkomak.com/pages/" + item.PageUrlGroup + '/' + item.PageKeyWord )
        } else {
          // this.$router.push({ path: '/question-info/' + item.PageKeyWord })
          window.open("https://blog.zoodkomak.com/Questions/" + item.PageKeyWord )
        }
      },
      go_to_add_question () {
        this.$router.push({ name: 'AddQuestion', params: {} })
      },
      goToDetail (item_id) {
        var PassingData = {}
        localStorage.setItem('request_data', JSON.stringify(PassingData))
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        passing_data.cat_id = item_id
        passing_data.request_name = this.$t('repair')
        localStorage.setItem('request_data', JSON.stringify(passing_data))

        this.$router.push({ name: 'groups', params: {} })
      },
      get_searches ($state) {
        var self = this
        const send_data = {
          searchType: '',
          searchParam: this.$route.params.search,
          page: this.page,
        }

        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://panel.zoodkomak.com/jetToken/SearchItems', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('response', response)
              // self.user_registered = true;
              // self.fullName = response.data.msg;
              // self.level = 2;
              self.items.push(...response.data.items.Items)
              if (response.data.items.Items.length > 0) {
                self.page++

                $state.loaded()
              } else {
                $state.complete()
              }
            } else {
              self.not_register = true
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      }
    }
  }
</script>
